import React, { FC, useState } from 'react';
import { NavFolders } from './folders/NavFolders';
import { Notification } from './notification/components/Notification';
import { NavReferral } from './pricing/NavReferral';
import { NavUser } from './user/NavUser';
import { Connect, PropsFromRedux } from './NavPrivateContainer';
import { UserContextType } from '../user/user.types';
import { NavPrivatePricing } from './pricing-button/NavPrivatePricing';
import { NavDocumentAnalyzer } from './document-analyzer/NavDocumentAnalyzer';

type Props = PropsFromRedux & {
  currentUser: UserContextType['currentUser'];
  accessPremium: UserContextType['accessPremium'];
};

/* 
  This is to manage the hover on NavPrivatePricing
  this context only carries a boolean and the method 
  updating it so that :hover can be prevented 
  if any of the other onClick Dropdown is triggered
*/
export const RawNavPrivate: FC<Props> = ({
  marketingLogged,
  accessPremium,
  currentUser: { askPhoneNumber, rights },
}) => {
  const [displayDropdown, setDisplayDropdown] = useState({
    user: false,
    folder: false,
    notification: false,
  });

  const cancelHover = (display: boolean, dropdown: string) =>
    setDisplayDropdown(prevDisplay => ({
      ...prevDisplay,
      [dropdown]: display,
    }));

  const noHover = Object.values(displayDropdown).reduce(
    (sum, curr) => sum || curr,
  );

  const displayDocumentAnalyzerLink = Boolean(
    rights && rights.includes('document_analyzer'),
  );

  if (marketingLogged) return null;

  return (
    <div className="nav" data-test-id="nav-private">
      <NavPrivatePricing noHover={noHover} />
      {displayDocumentAnalyzerLink ? <NavDocumentAnalyzer /> : <NavReferral />}
      {accessPremium && <NavFolders cancelHover={cancelHover} />}

      {!askPhoneNumber && (
        // @ts-ignore
        <Notification cancelHover={cancelHover} />
      )}
      <NavUser cancelHover={cancelHover} />
    </div>
  );
};

export const NavPrivate = Connect(RawNavPrivate);
